import React from 'react'
import MainLayout from '../../Layout/MainLayout'
// import storeData from '../../utils/storeData'
import { CartState } from "../../context/Context";

import CartTable from '../../components/Primary/CartTable'
import CartTotal from '../../components/Primary/CartTotal'

const Cart = () => {
 
  const {
    state: { cart },
    dispatch,
   
  } = CartState();

  return (
    
        <MainLayout>
            <div className="mb-6 md:mb-0 mt-4 md:mt-0 font-poppins ">
          
             <h1 className="font-poppins font-bold text-large" >
             Our Products
             </h1>
             <div className="underline" />
          </div>
          <div className="flex lg:space-x-6 mt-4 md:flex-row flex-col">
            {/* cart  Items */}
          <div className="flex flex-col w-full lg:w-1/2 mb-6 md:mb-0">
            { cart.length > 0 ? <CartTable   /> : <h1 className="text-center text-xl">No Items in Cart</h1>}
        

            
          {/* coupon session */}
          <div className="flex flex-row flex-wrap md:flex-row  lg:space-x-4 mt-4">
          <div className="md:w-3/12 w-5/12">
            <input type="text" className="w-full bg-light-blue p-2 border-none outline-none focus:outline-none " placeholder="Coupon code"/>
          </div>
          <div className="md:w-3/12 w-5/12">
           <button className="w-full bg-tradr-green py-2 px-3 border-none outline-none focus:outline-none text-white "> Apply Coupon</button>
          </div>
          <div className="md:w-3/12 w-5/12">
          <button className="w-full  p-2 border-none outline-none focus:outline-none text-ash"
          onClick={()=>dispatch({type:'CLEAR_CART'})}
          > Clear Cart</button>
          </div>
          <div className="md:w-3/12  w-5/12">
          <button className="w-full  p-2 border-none outline-none focus:outline-none text-ash ">Update</button>
          </div>
          
            </div>
            {/* end of coupon */}
            </div>
            {/* End of cart  Items */}

            {/* Check out part */}
            <div className="flex flex-col mt-4 md:mt-0 justify-start w-full lg:w-1/2">
            <CartTotal data={cart} value="#50000" />
              </div>
              {/* End of Check out part */}
            </div>

            </MainLayout>
    
  )
}

export default Cart